export function detectIE(): boolean {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  if (msie !== -1) {
    return true;
  }
  const trident = ua.indexOf('Trident/');
  return trident !== -1;
}

export function isEdge(): boolean {
  return /Edge/.test(navigator.userAgent);
}

export function isIOS(): boolean {
  return (
    !!window.navigator.userAgent.match(/(iPhone|iPad)/) ||
    (window.navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
}

export function isIphone(): boolean {
  return !!window.navigator.userAgent.match(/(iPhone)/);
}

export function getIOSVersion(): number | undefined {
  const regexMatch = navigator.userAgent.match(/\b[0-9]+_[0-9]+(?:_[0-9]+)?\b/);

  if (regexMatch) {
    const version = regexMatch[0].split('_')[0];
    return parseInt(version, 10);
  }

  return undefined;
}

export function isSafari(): boolean {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
